module.exports = "<i class=\"kl-icon kl-icon--{type} {class}\" style=\"font-size: {fontSize}px;color: {color}\" on-click=\"{this.onClick($event)}\"></i>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLIcon/index.html
// module id = 534
// module chunks = 0